<ng-container *ngIf="authService.isAuthenticated; else notAuthenticated">
  <block-ui>
    <app-header/>
    <main class="web-view" id="PageV">
      <router-outlet></router-outlet>
    </main>
  </block-ui>
</ng-container>
<ng-template #notAuthenticated>
  <div style="text-align: center; margin-top: 150px">
    <div class="spinner-grow text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow text-secondary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow text-success" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow text-danger" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow text-warning" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow text-info" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow text-light" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow text-dark" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-template>

<!-- app per i messaggi toast -->
<app-toasts-component class="ngb-toasts"
                      aria-live="polite" aria-atomic="true"></app-toasts-component>
